// extracted by mini-css-extract-plugin
export var deliveryRow = "_s2-a";
export var fixedHeight = "_s2-4";
export var freightLogo = "_s2-9";
export var fullWidth = "_s2-3";
export var priceColumn = "_s2-5";
export var radioSelected = "_s2-7";
export var radioUnselected = "_s2-6";
export var selectedOption = "_s2-2";
export var selectedOptionContainer = "_s2-1";
export var selection = "_s2-0";
export var tallSkeletonText = "_s2-8";